import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { EditGoal } from '../components/CollectionAndSequencing/Overview/SequenceGoal/SequenceGoal.types';
import { fetchGoals } from '../services/edit-goals.service';
import { STUDY_INSIGHTS_EDIT_GOALS } from '../constants';
import { useAuth } from '@modules/auth/hooks';

export const editGoalsDefaultValues: EditGoal = {
  baseline: null as any,
  startDate: '',
  endDate: '',
  goals: [
    {
      startDate: '',
      endDate: '',
      target: null as any,
      value: null as any,
    },
    {
      startDate: '',
      endDate: '',
      target: null as any,
      value: null as any,
    },
    {
      startDate: '',
      endDate: '',
      target: null as any,
      value: null as any,
    },
    {
      startDate: '',
      endDate: '',
      target: null as any,
      value: null as any,
    },
  ],
};

const useQueryEditGoals = <TError = unknown>(
  options?: Omit<
    UseQueryOptions<EditGoal | undefined, TError, EditGoal, string[]>,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<EditGoal> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([STUDY_INSIGHTS_EDIT_GOALS], async () => await fetchGoals(), {
    ...options,
    enabled: isAuthenticated === true && enabledOption,
    onError: (err: any) => {
      if (err?.statusCode === 404) {
        return editGoalsDefaultValues;
      }
    },
  });
};

export default useQueryEditGoals;
